"use strict";
// Stremio Plus: export and import of the account addons (owner profile only).
// Addon URLs can hold personal keys (debrid tokens...), so the file must stay private.
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.replaceAddons = exports.mergeAddons = exports.parseAddonsBackup = exports.downloadAddonsBackup = void 0;
var BACKUP_FORMAT = 'stremio-plus-addons';
var BACKUP_VERSION = 1;
var isDescriptor = function (value) {
    var _a, _b, _c;
    return typeof (value === null || value === void 0 ? void 0 : value.transportUrl) === 'string' &&
        /^https?:\/\//.test(value.transportUrl) &&
        typeof ((_a = value === null || value === void 0 ? void 0 : value.manifest) === null || _a === void 0 ? void 0 : _a.id) === 'string' &&
        typeof ((_b = value === null || value === void 0 ? void 0 : value.manifest) === null || _b === void 0 ? void 0 : _b.name) === 'string' &&
        typeof ((_c = value === null || value === void 0 ? void 0 : value.manifest) === null || _c === void 0 ? void 0 : _c.version) === 'string';
};
var downloadAddonsBackup = function (addons) {
    var backup = {
        format: BACKUP_FORMAT,
        version: BACKUP_VERSION,
        exportedAt: new Date().toISOString(),
        addons: addons.map(function (_a) {
            var transportUrl = _a.transportUrl, manifest = _a.manifest, flags = _a.flags;
            return ({ transportUrl: transportUrl, manifest: manifest, flags: flags });
        }),
    };
    var blob = new Blob([JSON.stringify(backup, null, 2)], { type: 'application/json' });
    var url = URL.createObjectURL(blob);
    var link = document.createElement('a');
    link.href = url;
    link.download = "stremio-plus-addons-".concat(new Date().toISOString().slice(0, 10), ".json");
    link.click();
    setTimeout(function () { return URL.revokeObjectURL(url); }, 1000);
};
exports.downloadAddonsBackup = downloadAddonsBackup;
// Accepts our backup file and, for convenience, a bare array of addon descriptors.
var parseAddonsBackup = function (text) {
    var json = JSON.parse(text);
    var list = Array.isArray(json) ? json : (json === null || json === void 0 ? void 0 : json.format) === BACKUP_FORMAT ? json.addons : null;
    if (!Array.isArray(list))
        throw new Error('Not a Stremio Plus addons file');
    var addons = list.filter(isDescriptor);
    if (addons.length === 0)
        throw new Error('No addon found in this file');
    return addons;
};
exports.parseAddonsBackup = parseAddonsBackup;
// "Add": keeps the current list and appends the addons it does not have yet.
var mergeAddons = function (current, imported) {
    var known = new Set(current.map(function (_a) {
        var transportUrl = _a.transportUrl;
        return transportUrl;
    }));
    return __spreadArray(__spreadArray([], current, true), imported.filter(function (_a) {
        var transportUrl = _a.transportUrl;
        return !known.has(transportUrl);
    }), true);
};
exports.mergeAddons = mergeAddons;
// "Replace": the imported list, plus the protected addons Stremio cannot run without.
var replaceAddons = function (current, imported) {
    var importedUrls = new Set(imported.map(function (_a) {
        var transportUrl = _a.transportUrl;
        return transportUrl;
    }));
    var kept = current.filter(function (_a) {
        var flags = _a.flags, transportUrl = _a.transportUrl;
        return (flags === null || flags === void 0 ? void 0 : flags.protected) && !importedUrls.has(transportUrl);
    });
    return __spreadArray(__spreadArray([], kept, true), imported, true);
};
exports.replaceAddons = replaceAddons;
